"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuContext = void 0;
var react_1 = require("react");
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
var noop = function () { };
exports.MenuContext = (0, react_1.createContext)({
    isShowing: false,
    isDismissible: false,
    isInverse: false,
    hasTriggerElement: false,
    onClose: noop,
    onItemSelected: noop,
    pattern: 'list',
});
//# sourceMappingURL=context.js.map